export interface IEditPersonalInfosRequest {
  email: string;
  phoneCode: string;
  countryCode: string;
  phone: string;
  dateOfBirth: string;
  instagram?: string;
}

export interface IEditCreatorPersonalInfosRequest {
  name: string;
  city: string;
  description: string;
  dateOfBirth: string;
  instagram?: string;
}

export interface IEditCreatorChatDefaultPageRequest {
  defaultPage: string;
  chat: string;
  isFreeSubscription?: boolean;
}

export interface IBillingAddressRequest {
  companyName?: string;
  address?: string;
  city?: string;
  postalCode?: number | string;
  country?: string;
  vatNumber?: string;
}

export const defaultEditPersonalInfosRequest: IEditPersonalInfosRequest = {
  email: "",
  phoneCode: "",
  countryCode: "",
  phone: "",
  dateOfBirth: "",
  instagram: "",
};

export const defaultCreatorEditPersonalInfosRequest: IEditCreatorPersonalInfosRequest = {
  name: "",
  dateOfBirth: "",
  city: "",
  description: "",
  instagram: "",
};

export const defaultCreatorEditChatDefaultPageInfosRequest: IEditCreatorChatDefaultPageRequest = {
  defaultPage: "",
  chat: "",
  isFreeSubscription: false,
};

export const initialBillingAddressRequest: IBillingAddressRequest = {
  companyName: "",
  address: "",
  city: "",
  postalCode: 0,
  country: "",
  vatNumber: "",
};
